import { render, staticRenderFns } from "./VaTreeNode.vue?vue&type=template&id=b513cf28&"
import script from "./VaTreeNode.vue?vue&type=script&lang=js&"
export * from "./VaTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./VaTreeNode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports